import { useEffect, useState } from 'react';
import cauzeStore from '../stores/CauzeStore';

const useCreateCauze = ({ userContext, eventId }) => {
  const [cauzeLoaded, setCauzeLoaded] = useState(false);

  useEffect(() => {
    cauzeStore.onCreateUnmount();
    if (eventId) {
      cauzeStore
        .loadCauzeToEdit({ userContext, eventId })
        .finally(() => setCauzeLoaded(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  return { cauzeLoaded };
};

export default useCreateCauze;
